import { Link } from 'react-router-dom';
import { fa_date } from '../../../../utils/PersianNum';
import { useGetBlogQuery } from '../../../../Redux/Apis/blogApi';

function Blog({site_id}) {
	const {data , isLoading } = useGetBlogQuery(site_id)

    return ( 
        <div className="blog-section">
            <div className="container">
                <div className="row">
                { 
					isLoading ? "در حال بارگذاری" 
                    :
					data && data.map((row,index) => 
                        <div className="col-12 col-sm-6 col-md-4 mb-5" key={index}>
                            <div className="post-entry">
                            <Link to={`/post/${row.id}`} className="post-thumbnail"><img src={row.image} alt="thumbnail" className="img-fluid"/></Link>
                                <div className="post-content-entry">
                                    <h3><Link to={`/post/${row.id}`}>{row.title}</Link></h3>
                                    <div className="meta">
                                        <span>در تاریخ {fa_date(row.create_date)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                </div>
            </div>
        </div>
    );
}

export default Blog;